// export const navServiceMenu=[
//     {
//         name:"E-Commerce",
//         link:"/services?serviceTitle=custom"
//     },
//     {
//         name:"Web Apps",
//         link:"/services?serviceTitle=application"
//     },
//     {
//         name:"Mobile Apps",
//         link:"/mobile"
//     },
//     {
//         name:"Cloud",
//         link:"/cloud"
//     },
//     {
//         name:"IOT",
//         link:"/iot"
//     },
//     {
//         name:"IT Security",
//         link:"/it-security"
//     },
//     {
//         name:"Other Services",
//         link:"/other"
//     },
// ]
export const navServiceMenu=[
    {
        name:"Custom Solutions",
        link:"/services?serviceTitle=custom",
        id:"custom",
    },
    {
        name:"Applications",
        link:"/services?serviceTitle=application",
        id:"application",
    },
    {
        name:"Cloud Solutions",
        link:"/services?serviceTitle=cloud",
        id:"cloud",
    },
    {
        name:"Saas Solutions",
        link:"/services?serviceTitle=saas",
        id:"saas",
    },
    
]

export const navProductMenu=[
    {
        name:"Internet Booking Platform",
        link:"/products/ipb",
    },
    {
        name:"Enterprise Asset Management",
        link:"/products/eam",
        
    },
    {
        name:"Safety Walk",
        link:"/products/safetywalk"
    },
    {
        name:"Secuity e-Form",
        link:"/products/e_form"
    },
    {
        name:"Online Job Training",
        link:"/products/ojt"
    },
    {
        name:"PTW",
        link:"/products/ptw"
    },

]